import React from 'react';
import styles from '../../styles/portfolio/short_desc.scss';


export const DistributedCounterDesc = props => {
    return (
        <div className={styles.description}>
            <div className={styles.containerGeneric}>
                Implementation of a highly available, low latency, and fault-tolerant distributed counter system,
                using Faust, RocksDB and Kafka. Results are real-time available through a UI.
                <span className={styles.tagContainer}>Stream Processing</span>
                <span className={styles.tagContainer}>Websockets</span>
            </div>
        </div>
    )
};
